export const TOKENKEY = 'koru_token';
// set token to local storage
// returns void
export const setTokenStorage = (token) => {
    localStorage.setItem(TOKENKEY, token);
};
export const getTokenStorage = () => {
    const token = localStorage.getItem(TOKENKEY);
    if (token) {
        return token;
    }
    return undefined;
};
// remove token from local storage
// returns void
export const removeTokenStorage = () => {
    localStorage.removeItem(TOKENKEY);
};
